module.exports = __webpack_public_path__ + "img/banner3.6a8fbe0c.png";